import { render, staticRenderFns } from "./UnCollectionChain.vue?vue&type=template&id=0800a5d8&"
import script from "./UnCollectionChain.vue?vue&type=script&lang=js&"
export * from "./UnCollectionChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports